import React from 'react';
import AdminLayout from "../../layouts/admin/AdminLayout";
import {Box} from "@mui/material";
import UsersTable from "../../components/admin/users/UsersTable";
import AuthContext from '../../route/AuthContext';
import {useLocation} from 'react-router-dom';
import BreadcrumbGenerator from '../../components/common/BreadcrumbGenerator';

const Users = () => {

  const {user} = React.useContext(AuthContext);
  const location = useLocation();

  const contentBreadcrumb = BreadcrumbGenerator.generateContent(user?.role ?? '', location.pathname);

  return (
    <AdminLayout
      breadcrumb={contentBreadcrumb}
      title="Utenti | Piattaforma Innovation ReSearch">
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 1
      }}>
        <UsersTable />
      </Box>
    </AdminLayout>
  );
};

export default Users;
